<template>
    <section
        class="cart-popup cart-popup__modal modal bd-example-modal-lg"
        tabindex="-1"
        role="dialog"
        data-focus="false"
        aria-labelledby="cartPopup"
        aria-hidden="true"
        ref="bootstrap_modal"
    >
        <div class="modal-dialog modal-lg">
            <div class="hidden-lg-up">
                <div class="modal-content cart-popup__modal-content">
                    <div class="cart-popup__mobile-block">
                        <div class="cart-popup__mobile-header d-flex align-items-center justify-content-between">
                            <svg class="cart-popup__mobile-header-check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>
                            <span class="px-4">{{ $t("blockCart.addedToCartTitle") }}</span>
                            <div class="d-flex justify-content-center">
                                <a
                                    :href="checkoutUrl"
                                    class="cart-popup__button--cart h-100 align-items-center"
                                    id="cart-btn"
                                >
                                    <i class="fa fa-shopping-cart header__button--fa text-white" aria-hidden="true"></i>

                                    <div class="cart-popup__badge-wrapper">
                                        <div
                                            id="cart-badge--mobile"
                                            class="badge badge-small badge-pill badge-danger ajax_cart_quantity badge-small hidden"
                                        >
                                            <span>{{ cartTotalProductsCount }}</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="cart-popup__mobile-body">
                            <div class="row px-4 py-3" v-if="latestAddedProduct">
                                <div class="col-12 px-4">
                                    <span><strong>{{ $t("blockCart.addedToCartChoiceTitle") }}</strong></span>
                                    <div>
                                        {{ latestAddedProduct.name }}
                                    </div>
                                    <div>
                                        {{ latestAddedProduct.attributes }}
                                    </div>
                                </div>
                            </div>
                            <div class="row px-4 py-3">
                                <div class="d-flex align-items-center">
                                    <button
                                        @click="showBlockCart = false"
                                        class="btn btn-link"
                                    >
                                        <span>{{ $t('blockCart.continueShopping') }}</span>
                                    </button>
                                </div>
                                <div class="col">
                                    <a
                                        :href="checkoutUrl"
                                        class="cart-modal__checkout button button--yellow button--icon-right w-100 cart-popup__checkout-button"
                                        :title="$t('blockCart.proceedToCheckout')"
                                    >
                                        <div></div>
                                        <span>{{ $t("blockCart.proceedToCheckout") }}</span>
                                        <i class="far fa-chevron-right"></i>
                                    </a>
                                </div>
                            </div>
                            <div
                                v-if="shouldShowFrequentlyBoughtTogetherSection"
                                class="d-flex flex-column cart-popup__mobile-footer px-4 py-3"
                            >
                                <div class="mb-4">
                                    <h4>{{ $t("blockCart.frequentlyBoughtTogether") }}</h4>
                                </div>

                                <CartRecommendedProducts
                                    :is-fetching-cart-recommendations="isFetchingCartRecommendations"
                                    :cart-recommendations-limit="cartRecommendationsLimit"
                                    :cart-recommendations="cartRecommendations"
                                ></CartRecommendedProducts>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hidden-md-down">
                <div class="modal-content modal-content--white">
                    <div class="cart-popup__desktop-block">
                        <div class="cart-popup__product">
                            <div class="cart-popup__product__wrapper">
                                <div class="cart-popup__header">
                                    <div class="row">
                                        <div class="col-8">
                                            <h3>{{ $t("blockCart.addedToCartTitle") }}</h3>
                                            <div v-if="latestAddedProduct">
                                                <div>
                                                    {{ latestAddedProduct.name }}
                                                </div>
                                                <div>
                                                    {{ latestAddedProduct.attributes }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <a
                                                :href="checkoutUrl"
                                                class="cart-modal__checkout button button--yellow button--icon-right w-100 cart-popup__checkout-button"
                                                :title="$t('blockCart.proceedToCheckout')"
                                            >
                                                <div></div>
                                                <span>{{ $t("blockCart.proceedToCheckout") }}</span>
                                                <i class="far fa-chevron-right"></i>
                                            </a>
                                            <button
                                                @click="showBlockCart = false"
                                                class="cart-popup__link"
                                            >
                                                {{ $t("blockCart.continueShopping") }}
                                            </button>
                                        </div>
                                        <div class="col-1">
                                            <button
                                                @click="showBlockCart = false"
                                                class="cart-popup__back button--clear cursor-pointer"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                                    <path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="shouldShowFrequentlyBoughtTogetherSection"
                                    class="cart-popup__body"
                                >
                                    <div class="mb-4">
                                        <h4>{{ $t("blockCart.frequentlyBoughtTogether") }}</h4>
                                    </div>

                                    <CartRecommendedProducts
                                        :is-fetching-cart-recommendations="isFetchingCartRecommendations"
                                        :cart-recommendations-limit="cartRecommendationsLimit"
                                        :cart-recommendations="cartRecommendations"
                                    ></CartRecommendedProducts>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import axios from "axios";
import CartRecommendedProducts from "./CartRecommendedProducts";
import BlockCartItem from "./BlockCartItem";
import InputText from "./Address/InputText.vue";

export default {
    name: 'BlockCart',
    components: { InputText, BlockCartItem, CartRecommendedProducts },
    props: {
        checkoutUrl: {
            required: true,
            type: String,
        },
        cartRecommendationsUrl: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            idCart: null,
            showBlockCart: false,
            latestAddedProduct: null,
            allProducts: [],
            shippingCost: null,
            cartTotal: null,
            cartTotalProductsCount: null,
            latestAddedProductPanelIsOpen: true,
            cartRecommendationsLimit: 6,
            isFetchingCartRecommendations: false,
            cartRecommendations: [],
        }
    },
    computed: {
        otherProductsInCart() {
            if (! this.latestAddedProduct) {
                return this.allProducts;
            }

            return this.allProducts.filter((product) => {
                if (product.id !== this.latestAddedProduct.id) {
                    return true
                }
                if (product.idCombination !== this.latestAddedProduct.idCombination) {
                    return true
                }

                return false;
            });
        },
        limitedOtherProductsInCart() {
            const productLimit = this.latestAddedProduct ? 3 : 4;

            return this.otherProductsInCart.filter((product, index) => index < productLimit);
        },
        shouldShowFrequentlyBoughtTogetherSection() {
            return (
                (this.isFetchingCartRecommendations) ||
                ((!this.isFetchingCartRecommendations) && this.cartRecommendations.length > 0)
            )
        },
    },
    watch: {
        showBlockCart(shouldShow) {
            if (shouldShow) {
                document.body.classList.add('cart-popup__modal--disable-jump');
            } else {
                document.body.classList.remove('cart-popup__modal--disable-jump');
            }

            $('.cart-popup').modal(shouldShow ? 'show' : 'hide');
            $('#js_blockcart').css('z-index', shouldShow ? '999999' : '-999999');

            if (shouldShow) {
                $('.js_hide_blockcart').click((event) => {
                    if (event.target.classList.contains('js_hide_blockcart')) {
                        this.showBlockCart = false;
                    }
                });
            }
        }
    },
    mounted() {
        const blockCartVueApp = this;

        window.EventBus.$on('block-cart-update', (blockCartData) => {
            blockCartVueApp.allProducts            = blockCartData.allProducts;
            blockCartVueApp.idCart                 = blockCartData.cartData.idCart;
            blockCartVueApp.shippingCost           = blockCartData.cartData.shippingCost;
            blockCartVueApp.cartTotal              = blockCartData.cartData.total;
            blockCartVueApp.cartTotalProductsCount = blockCartData.cartData.nbTotalProducts;

            if (blockCartData.addedProduct) {
                blockCartVueApp.latestAddedProduct = blockCartData.addedProduct;
            }

            if (! blockCartData.addedProduct && blockCartVueApp.latestAddedProduct) {
                const latestAddedProductInCart = blockCartData.allProducts.find((product) =>
                    Number(product.id) === Number(blockCartVueApp.latestAddedProduct.id) &&
                    Number(product.idCombination) === Number(blockCartVueApp.latestAddedProduct.idCombination)
                );

                if (! latestAddedProductInCart) {
                    blockCartVueApp.latestAddedProduct = null;
                }
            }

            if (blockCartData.openCartModal) {
                if (! blockCartVueApp.showBlockCart) {
                    // Only fetch it if we aren't already showing the popup with recommendations
                    blockCartVueApp.fetchCartRecommendations();
                }

                blockCartVueApp.showBlockCart = true;
            }

            if (! blockCartVueApp.allProducts.length) {
                blockCartVueApp.showBlockCart = false;
            }
        });

        $('.cart-popup').on('show.bs.modal', () => {
            this.showBlockCart = true;
        });

        $('.cart-popup').on('hide.bs.modal', () => {
            this.showBlockCart = false;
        });
    },
    methods: {
        fetchCartRecommendations() {
            if (! this.cartRecommendationsUrl || ! this.latestAddedProduct || this.isFetchingCartRecommendations) {
                return;
            }

            this.cartRecommendations = [];
            this.isFetchingCartRecommendations = true;

            const requestData = {
                product_id: this.latestAddedProduct.id,
                cart_id: this.idCart,
                limit: this.cartRecommendationsLimit,
                allow_filler: 0
            };

            axios.get(this.cartRecommendationsUrl, { params: requestData })
                 .then((response) => {
                     this.cartRecommendations = response.data.recommendations;
                 })
                 .finally(() => this.isFetchingCartRecommendations = false);
        }
    }
}
</script>
